module.exports = __webpack_public_path__ + "static/media/ao.165dca7b.jpeg";